import { config } from "../configs/repositoryConfig";
import backendHttpRequest from "./backendHttpRequest";
import { convertToQueryString } from "../utilities/httpUtils";
import { replaceAllStringByKeys } from "../utilities/stringUtils";

export const getCurrentUser = async () => {
  return await backendHttpRequest({
    resourceObject: config.backendApiSettings.resources.getCurrentUser,
  });
};

export const getUsers = async (filteredObject) => {
  const queryString = convertToQueryString(filteredObject);
  const resourceObject = {
    ...config.backendApiSettings.resources.getUsers,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}${queryString ? `?${queryString}` : ""}`;

  return await backendHttpRequest({ resourceObject });
};

export const getUserById = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.getUserById,
  };

  resourceObject.endpoint = replaceAllStringByKeys(
    resourceObject.endpoint,
    [":id"],
    [id],
  );

  return await backendHttpRequest({ resourceObject });
};

export const removeUser = async (userId) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.deleteUser,
  };

  resourceObject.endpoint = replaceAllStringByKeys(
    resourceObject.endpoint,
    [":userId"],
    [userId],
  );

  await backendHttpRequest({ resourceObject });

  return userId;
};

export const createUser = async (body) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.createUser,
  };

  return await backendHttpRequest({
    resourceObject,
    body,
  });
};

export const updateUser = async (body) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.updateUser,
  };

  return await backendHttpRequest({
    resourceObject,
    body,
  });
};
